
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABpUExURQAAAP////////////////////////////////// //////Dy98XO35mpyIudwJKjxKi20KGwzOnt8+Lm7/j5+7bB15qpyNvg66GvzOns88XO4OLn7/Hz 977I3MzU49Pa577H26+71AAAAE188OoAAAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAAAWJLR0QAiAUd SAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IlSlicsAAACwSURBVCjPhZLbEoIw DAVDaAHDpWqholbF//9JQWhRJ8F9PNtMOkkARhJM6QulM5jJC2LA/O0UsajJFiSAABmJJKBliRA6 llWkXKIUwrO6idQhi7L5gJXGiHJ/OFpRtkSda+nEyv7cNaaqeqHnxocuRHLPa2nJeX/jZevJ3B8D K5/WDhtD2JyQKN3qXJThtPy6Mr9EClBetoZEluN5iqX47zQhZ2vnox7J9E91irspfwE5sCB3+dsE xgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQwMjozMjoxNSswMDowMJPflswAAAAldEVY dGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6MTYrMDA6MDDTajTtAAAAKHRFWHRkYXRlOnRp bWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM0KzAwOjAwgs/b5AAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    